import { type ReactElement } from 'react'

// @mui imports
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'

import type { KNMenuItemProps } from './types'

const KNMenuItem = ({
  label,
  icon,
  onClick,
  hasBottomBorder,
}: KNMenuItemProps): ReactElement => (
  <>
    <MenuItem onClick={onClick}>
      {icon}
      {label}
    </MenuItem>
    {hasBottomBorder && <Divider />}
  </>
)

export default KNMenuItem
